import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.to-fixed.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('PageTop1'), _c('PageTop'), _c('div', {
    staticClass: "pay-ment-box"
  }, [_vm.type === 'bill' ? _c('div', {
    staticClass: "total-amount-box"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": require("./image/icon_submit.png"),
      "alt": ""
    }
  }), _c('div', [_c('p', [_vm._v("账单支付！")]), _c('p', [_c('span', [_vm._v("账单编号：" + _vm._s(_vm.bill.data.documentNo))]), _c('span', [_vm._v("账单周期：" + _vm._s(_vm.bill.data.billCycle))])])])]), _c('div', {
    staticClass: "right"
  }, [_c('p', [_vm._v("总计")]), _c('p', [_vm._v("¥")]), _c('p', [_vm._v(_vm._s(_vm.bill.data.accountsPayable))])])]) : _c('div', {
    staticClass: "total-amount-box"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    attrs: {
      "src": require("./image/icon_submit.png"),
      "alt": ""
    }
  }), _c('div', [_c('p', [_vm._v("订单提交成功，请尽快支付！")]), _c('p', {
    staticClass: "cd"
  }, [_vm._v(" 请在 "), _vm.countDown.show ? _c('span', [_c('countdown', {
    attrs: {
      "value": _vm.countDown.value,
      "format": "h时m分s秒"
    },
    on: {
      "stop": _vm.countDownStopHandler
    }
  })], 1) : _vm._e(), _vm._v(" 内完成支付，否则订单会被自动取消 ")]), _c('p', [_c('span', [_vm._v("订单编号：" + _vm._s(_vm.order.data.orderNumber))]), _c('span', [_vm._v("商品名称：" + _vm._s(_vm.order.data.productName))]), _c('span', [_vm._v("下单时间：" + _vm._s(_vm.order.data.orderAt))])])])]), _c('div', {
    staticClass: "right",
    staticStyle: {
      "display": "flex",
      "flex-direction": "column"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "16px",
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("总计：")]), _c('span', {
    class: {
      'total-amount': _vm.actIndex == 1
    }
  }, [_vm._v("¥")]), !_vm.orderAmountInfo.id ? _c('span', {
    class: {
      'total-amount': _vm.actIndex == 1
    }
  }, [_vm._v(_vm._s(_vm.payment.list.tatil || 0))]) : _c('span', {
    class: {
      'total-amount': _vm.actIndex == 1
    }
  }, [_vm._v(" " + _vm._s(_vm.orderAmountInfo.oldRealPayAmount ? _vm.orderAmountInfo.oldRealPayAmount.toFixed(2) : '0:00') + " ")])]), _vm.actIndex == 0 && _vm.orderAmountInfo.id ? [_c('div', {
    staticStyle: {
      "font-size": "16px",
      "color": "#ff3f3f"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "14px"
    }
  }, [_vm._v("立减：")]), _c('span', [_vm._v("¥")]), _c('span', [_vm._v(_vm._s(_vm.orderAmountInfo.onlinePaymentInstantDiscount ? _vm.orderAmountInfo.onlinePaymentInstantDiscount.toFixed(2) : '0.00'))])]), _c('div', {
    staticStyle: {
      "font-size": "20px",
      "color": "#ff3f3f",
      "font-weight": "bold",
      "margin-top": "4px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "18px"
    }
  }, [_vm._v("实付：")]), _c('span', [_vm._v("¥")]), _c('span', [_vm._v(_vm._s(_vm.orderAmountInfo.realPayAmount ? _vm.orderAmountInfo.realPayAmount.toFixed(2) : '0.00'))])])] : _vm._e()], 2)]), _vm.payment && _vm.payment.list && (_vm.payment.list.immediatePayment || _vm.payment.list.offlinePayment) ? _c('div', {
    staticClass: "pay-type-box"
  }, [_vm._m(0), _vm.payment && _vm.payment.list && _vm.payment.list.immediatePayment ? _c('div', {
    staticClass: "payTabs"
  }, [_vm.payment.list.immediatePayment.show ? _c('div', {
    class: ['item', _vm.payment.list.immediatePayment.checked ? 'act_item' : ''],
    on: {
      "click": function click($event) {
        return _vm.tabChange(_vm.payment.list.immediatePayment.title, 0, _vm.payment.list.immediatePayment.money);
      }
    }
  }, [_c('div', {
    staticClass: "onLineBox"
  }, [_c('div', {
    staticClass: "onLine-le"
  }, [_c('span', {
    staticClass: "onLine-le-title"
  }, [_vm._v(_vm._s(_vm.payment.list.immediatePayment.title))])]), _vm.payment.list.immediatePayment.addedTitle && _vm.payment.list.immediatePayment.addedTitle > '0' ? _c('div', {
    class: ['onLine-ri', _vm.payment.list.immediatePayment.checked ? '' : 'dis_item']
  }, [_vm._v("（最高享" + _vm._s(_vm.payment.list.immediatePayment.addedTitle) + "‰立减）")]) : _vm._e()])]) : _vm._e(), _vm.payment.list.offlinePayment.show ? _c('div', {
    class: ['item', _vm.payment.list.offlinePayment.checked ? 'act_item' : ''],
    on: {
      "click": function click($event) {
        return _vm.tabChange(_vm.payment.list.offlinePayment.title, 1, _vm.payment.list.offlinePayment.money);
      }
    }
  }, [_c('div', {
    staticClass: "onLineBox"
  }, [_c('div', {
    staticClass: "onLine-le"
  }, [_c('span', {
    staticClass: "onLine-le-title"
  }, [_vm._v(_vm._s(_vm.payment.list.offlinePayment.title))])]), _c('div', {
    class: ['onLine-ri', _vm.payment.list.offlinePayment.checked ? '' : 'dis_item']
  }, [_vm._v(_vm._s(_vm.payment.list.offlinePayment.payName == "COD" ? "(送货上门、收货付款)" : "(优惠)"))])])]) : _vm._e()]) : _vm._e(), _vm.actIndex === 0 ? _c('div', {
    staticClass: "payTypeBox"
  }, [_vm.payment.list.immediatePayment && _vm.payment.list.immediatePayment.list && _vm.payment.list.immediatePayment.list.length > 0 ? _c('div', _vm._l(_vm.payment.list.immediatePayment.list, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "payTypeBox-list"
    }, [_c('div', {
      staticClass: "title"
    }, [_c('span', [_vm._v(_vm._s(item.title))]), item.onlinePaymentPercentage ? _c('span', {
      staticClass: "des"
    }, [_vm._v("(享" + _vm._s(item.onlinePaymentPercentage) + "‰立减 自动下账)")]) : _vm._e()]), item.title == '公对公支付' ? _c('p', {
      staticClass: "bk_des"
    }, [_c('span', {
      staticClass: "iconfont icon-prompt-fill sp"
    }), _vm._v(" 请确认已插入企业网银UKEY，以便正常使用企业网银支付。 ")]) : _vm._e(), _c('div', {
      staticClass: "typeList"
    }, _vm._l(item.list, function (temp, tindex) {
      return _c('div', {
        key: tindex,
        class: ['payItem', _vm.payment.mode == temp.code && _vm.currentTitle == item.title ? 'act_pay' : ''],
        on: {
          "click": function click($event) {
            return _vm.choosePayWay(temp, item.title);
          }
        }
      }, [_c('div', {
        staticStyle: {
          "width": "40px",
          "text-align": "center",
          "margin-left": "8px"
        }
      }, [_c('span', {
        class: ['iconfont', temp.icon],
        style: {
          'color': temp.color
        }
      })]), _c('div', {
        staticStyle: {
          "flex": "1"
        }
      }, [_c('div', [_vm._v(_vm._s(temp.name))]), _c('div', {
        staticStyle: {
          "font-size": "12px",
          "color": "#878787"
        }
      }, [_vm._v(_vm._s(temp.subheading))]), item.type == -1 && temp.onlinePaymentPercentage ? _c('div', {
        staticStyle: {
          "font-size": "12px"
        },
        style: {
          'color': temp.type === 'ONLINE' ? '#878787' : 'red'
        }
      }, [_vm._v(" 享" + _vm._s(temp.onlinePaymentPercentage) + "‰立减 ")]) : _vm._e()])]);
    }), 0)]);
  }), 0) : _vm._e()]) : _c('div', {
    staticClass: "payTypeBox"
  }, [_vm.payment.list.offlinePayment.payName == 'COD' ? _c('div', [_c('div', {
    staticClass: "tips",
    style: {
      'font-size': _vm.payment.list.offlinePayment.list[0].font,
      'color': _vm.payment.list.offlinePayment.list[0].color
    }
  }, [_vm._v(" " + _vm._s(_vm.payment.list.offlinePayment.list[0].title) + " ")]), _c('div', {
    staticClass: "channels",
    style: {
      'font-size': _vm.payment.list.offlinePayment.list[1].font,
      'color': _vm.payment.list.offlinePayment.list[1].color
    }
  }, [_vm._v(" " + _vm._s(_vm.payment.list.offlinePayment.list[1].title) + " ")]), _c('div', {
    staticClass: "channels-des",
    style: {
      'font-size': _vm.payment.list.offlinePayment.list[2].font,
      'color': _vm.payment.list.offlinePayment.list[2].color
    }
  }, [_vm._v(" " + _vm._s(_vm.payment.list.offlinePayment.list[2].title) + " ")]), _c('div', {
    staticStyle: {
      "font-size": "16px",
      "font-weight": "bold",
      "margin-top": "30px",
      "text-align": "left"
    }
  }, [_vm._v("对公转账信息")]), _c('div', {
    staticStyle: {
      "position": "relative"
    },
    style: {
      height: _vm.expandOrNot ? 'auto' : '190px',
      'overflow': _vm.expandOrNot ? 'auto' : 'hidden'
    }
  }, [_vm._l(_vm.payment.list.offlinePayment.list2, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "toBankMsg"
    }, [_c('div', {
      staticClass: "toBankMsgBox"
    }, [_c('div', {
      staticClass: "toBankMsg-name",
      style: {
        'background': item.recommend == 1 ? '#ff5a5a' : '#999999'
      }
    }, [_vm._v(_vm._s(item.title))]), _c('div', {
      staticClass: "des"
    }, [_vm._v("复制22位账号，对公付款 自动下账")])]), _c('div', {
      staticClass: "toBankMsg-content"
    }, [_c('div', {
      staticClass: "tbm-item"
    }, [_c('div', {
      staticClass: "label-name"
    }, [_vm._v("单位名称")]), _c('div', [_vm._v(_vm._s(item.companyName))])]), _c('div', {
      staticClass: "tbm-item"
    }, [_c('div', {
      staticClass: "label-name"
    }, [_vm._v("账户")]), _c('div', {
      staticClass: "bankNum"
    }, [_c('span', [_vm._v(_vm._s(item.account))]), item.recommend == 1 ? _c('span', [_vm._v(_vm._s(_vm.userInfo.account))]) : _vm._e(), _c('span', {
      staticClass: "copyBox",
      on: {
        "click": function click($event) {
          return _vm.copyCode(item, _vm.userInfo.account);
        }
      }
    }, [_vm._v("复制")])])]), _c('div', {
      staticClass: "tbm-item"
    }, [_c('div', {
      staticClass: "label-name"
    }, [_vm._v("开户行")]), _c('div', [_vm._v(_vm._s(item.bankAddress))])])])]);
  }), _c('div', {
    staticClass: "expand-button",
    style: {
      'position': !_vm.expandOrNot ? 'absolute' : 'initial'
    },
    on: {
      "click": function click($event) {
        _vm.expandOrNot = !_vm.expandOrNot;
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.expandOrNot ? '收起' : '展开更多'))]), _c('i', {
    staticClass: "el-icon-d-arrow-right",
    style: {
      'transform': _vm.expandOrNot ? 'rotate(-90deg)' : 'rotate(90deg)'
    }
  })])], 2)]) : _c('div', [_c('div', {
    staticClass: "xx-des"
  }, [_vm._v("专属开票员会主动联系你，注意电话接听~")])])]), _vm.actIndex === 0 && _vm.payment.mode == '' ? _c('p', {
    staticClass: "payMsg"
  }, [_vm._v("请选择支付方式")]) : _vm._e(), _c('div', {
    staticClass: "button-box"
  }, [_vm.actIndex === 0 ? [!_vm.payment.mode || _vm.payment.mode === 'FRIENDTOPAY' ? _c('div', {
    staticClass: "payBtn"
  }, [_vm._v("选择支付（银行）")]) : _c('div', {
    staticClass: "payBtn actBtn animated delay1",
    on: {
      "click": function click($event) {
        return _vm.toPayModal('ONLINE');
      }
    }
  }, [_vm._v("确认订单（立即支付）")])] : _vm.actIndex === 1 ? [!_vm.payment.list.offlinePayment.checked ? _c('div', {
    staticClass: "payBtn"
  }, [_vm._v(_vm._s(_vm.payment.list.offlinePayment.payName == 'COD' ? "确认订单（货到付款）" : "确认订单（线下付款）"))]) : _c('div', {
    staticClass: "payBtn actBtn animated delay1",
    on: {
      "click": function click($event) {
        return _vm.toPayModal('OFFLINE');
      }
    }
  }, [_vm._v(_vm._s(_vm.payment.list.offlinePayment.payName == 'COD' ? "确认订单（货到付款）" : "确认订单（线下付款）"))])] : _vm._e()], 2)]) : _vm._e()]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.qrCodeModal.show,
      expression: "qrCodeModal.show"
    }],
    staticClass: "model-box"
  }, [_c('div', {
    staticClass: "center-box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('p', [_vm._v("微信/支付宝支付")]), _c('img', {
    attrs: {
      "src": require("./image/icon_close.svg"),
      "alt": ""
    },
    on: {
      "click": _vm.closePayModal
    }
  })]), _c('div', {
    staticClass: "box-content"
  }, [_c('div', {
    staticClass: "box-pay"
  }, [_c('div', {
    staticClass: "qrcode-countdown"
  }, [_vm.countDown.value ? _c('span', [_vm._v(" 距离二维码过期还剩 "), _c('countdown', {
    staticStyle: {
      "color": "rgba(244, 87, 87, 1)"
    },
    attrs: {
      "value": _vm.countDown.value,
      "format": "h时m分s秒"
    },
    on: {
      "stop": _vm.countDownStopHandler
    }
  }), _vm._v("，过期后请重新获取二维码。 ")], 1) : _vm._e()]), _c('div', {
    staticClass: "code-box"
  }, [_c('img', {
    attrs: {
      "alt": "二维码",
      "src": _vm.qrCodeModal.qrCodeUrl
    }
  })]), _c('p', [_vm._v("请使用微信或支付宝扫一扫 扫码支付")])]), _c('div', {
    staticClass: "title-box"
  }, [_c('p', [_vm._v(" 交易金额 "), _vm.type === 'bill' ? _c('span', [_vm._v(_vm._s(_vm.bill.data.accountsPayable))]) : [_vm.actIndex == 0 && _vm.orderAmountInfo.id ? _c('span', [_vm._v(_vm._s(_vm.orderAmountInfo.realPayAmount ? _vm.orderAmountInfo.realPayAmount.toFixed(2) : '0.00'))]) : _c('span', [_vm._v(_vm._s(_vm.orderAmountInfo.oldRealPayAmount ? _vm.orderAmountInfo.oldRealPayAmount.toFixed(2) : '0.00'))])], _vm._v(" 元 ")], 2)])])])]), _c('Dialog', {
    attrs: {
      "show": _vm.showDebt,
      "title": _vm.arrearsData.debitFlag,
      "width": "400px",
      "height": "300px"
    },
    on: {
      "close": function close($event) {
        _vm.showDebt = false;
      }
    }
  }, [_c('div', {
    staticClass: "arrears-dialog",
    staticStyle: {
      "border-radius": "10px"
    }
  }, [_c('div', {
    staticClass: "proBox1"
  }, [_vm.arrearsData.currentSumDebit > 0 ? _c('div', {
    staticClass: "proBox-msg"
  }, [_c('p', [_vm._v("截止当前，"), _c('span', {
    staticStyle: {
      "color": "#E5432E"
    }
  }, [_vm._v("您已累计欠款" + _vm._s(_vm.arrearsData.currentSumDebit) + "元，")])]), _c('p', [_vm._v("为不影响您正常下单，请立即还款。")])]) : _vm._e(), _vm.arrearsData.currentSumDebit == 0 ? _c('div', {
    staticClass: "proBox-msg"
  }, [_c('p', [_vm._v("请联系业务员调整授信额度。")])]) : _vm._e(), _vm.arrearsData.currentSumDebit > 0 ? _c('div', {
    staticClass: "proBox-btn",
    on: {
      "click": _vm.nowArrears
    }
  }, [_c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.nowArrears
    }
  }, [_vm._v("立即还款")])]) : _vm._e()])])]), _c('PageBottom')], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('p', {
    staticClass: "titleBox"
  }, [_c('span', [_vm._v("支付方式")]), _c('span', {
    staticStyle: {
      "color": "#E5432E",
      "font-size": "14px",
      "margin-left": "10px"
    }
  }, [_vm._v("*请选择以下两种方式（否则订单会被取消）")])]);
}];
export { render, staticRenderFns };